import { Accordion } from "@mui/material";
import {styled} from "@mui/material/styles";

export const PlotPlanContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    padding: 10,
    boxSizing: 'border-box'
}))

export const CustomAccordion = styled(Accordion)(({expanded}) => ({
    borderRadius: '10px !important',
    marginBottom: '10px',
    border: '1px solid #e8e8e9',
    backgroundColor: '#fbfcfd',
    boxShadow: 'none',
    '&:before': { display: 'none' },
    display: 'flex',
    flexDirection: 'column',
    flex: expanded ? 1 : 'unset',
    overflow: 'hidden',
    width: '100%',
    boxSizing: 'border-box',
}))